import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';

interface CheckPhotoParams {
  ProductCode: string;
  MimeType?: string;
  DocumentData?: string;
  CustomerNumber?: number;
  SessionToken?: string;
}

const command = 'RI.OnCheckPhoto';

const checkPhotoValidity = async (params: CheckPhotoParams): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default checkPhotoValidity;
